<template>
  <div class="index">
    <main class="cf w-100 ph3 ph4-m ph5-ns pv6" style="position:relative; z-index:1;">
        <div v-for="(photo, index) in allPhotos" v-bind:key="photo.id"
          class="fl w-100 w-50-m w-25-ns pb4 ph3-ns">
          <div class="aspect-ratio aspect-ratio--16x9">
            <div :style="{'background-image': 'url(' + photo.data.photo_thumbnail.url.substring( 0, photo.data.photo_thumbnail.url.indexOf( '?auto=compress,format' )) + ')'}"
                 @click="goPhoto(index)"
                 class="bg-center cover dim pointer aspect-ratio--object"></div>
          </div>
        </div>
    </main>
  </div>
</template>

<script>
// @ is an alias to /src
// import Item from '@/components/Item.vue'

export default {
  name: 'index',
  components: {
    // Item
  },
  data() {
    return {
      allPhotos: []
    }
  },
  methods: {
    goPhoto(photoId) {
      this.$router.push({ name: 'photo', params: { photo_id: photoId } });
    }
  },
  created() {
    var that = this;
    this.$store.dispatch('fetchPhotos', { vm: this, cb:
      function(results) {
        // that.allPhotos = results;
        that.allPhotos = results.sort((a, b) => parseInt(b.data.order) - parseInt(a.data.order));
      }
    });
  }
}
</script>

<style scoped>
  img {
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
  }
</style>
